'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.connectedUpgradeDataPropsInterface = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _PromptablePropInterface = require('UIComponents/decorators/PromptablePropInterface');

var _PromptablePropInterface2 = _interopRequireDefault(_PromptablePropInterface);

var _products = require('ui-addon-upgrades/_core/common/data/upgradeData/properties/products');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var connectedUpgradeDataPropsInterface = exports.connectedUpgradeDataPropsInterface = _extends({
  upgradeData: _react.PropTypes.shape({
    product: _react.PropTypes.oneOf(_products.productValues).isRequired,
    app: _react.PropTypes.string.isRequired,
    screen: _react.PropTypes.string.isRequired,
    source: _react.PropTypes.string.isRequired,
    type: _react.PropTypes.string.isRequired,
    campaign: _react.PropTypes.string.isRequired,
    trialId: _react.PropTypes.number
  }).isRequired
}, _PromptablePropInterface2.default);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/common/data/upgradeData/interfaces/connectedUpgradeDataPropsInterface.js
// module id = 255
// module chunks = 3 4 5